import React from "react"

const DisposalDescription = props => {
  return (
    <div className="field-item even" property="content:encoded">
      <p>
        Applications for guidance and advice on disposal of various products
      </p>
      <p>
        <strong>
          <em>What the service is about</em>
        </strong>
      </p>
      <p>
        Owners, producers, handlers or other people having in their custody
        products&nbsp; that may cause a negative environmental impact when not
        properly handled or disposed of, need advice from REMA on the proper
        disposal modes.
      </p>
      <p>
        This service allows custodians of such products to apply to REMA for
        authorization and guidance for disposal.
      </p>
      <p>
        <strong>
          <em>Who are provided the service</em>
        </strong>
      </p>
      <p>
        Custodians in the public or private sector of products likely cause a
        negative environmental impact when not properly handled or disposed of,
        especially hazardous, toxic, expired or substandard products.
      </p>
      <p>
        <strong>
          <em>Service processes (steps)</em>
        </strong>
      </p>
      <p>
        1.&nbsp;&nbsp; &nbsp;Application by the holder with details on the
        nature, type, quantities and specifications of products to dispose of
        <br></br>
        2.&nbsp;&nbsp; &nbsp;Inspection of products by REMA and assessment of
        the appropriate disposal options<br></br>
        3.&nbsp;&nbsp; &nbsp;Response to the applicant with details on
        requirements and procedures for disposal<br></br>
        4.&nbsp;&nbsp; &nbsp;Follow up of the disposal by REMA
      </p>
      <p>
        <strong>
          <em>Required documents( for application)</em>
        </strong>
      </p>
      <p>Technical specifications of the products</p>
      <p>
        <strong>
          <em>Important notice to applicants (if any)</em>
        </strong>
      </p>
      <p>
        -&nbsp;&nbsp; &nbsp;The cost of disposal is paid by the applicant
        <br></br>
        -&nbsp;&nbsp; &nbsp;REMA does not charge any fee for the visit and
        guidance
      </p>
      <p>
        <strong>
          <em>Important links (if any)</em>
        </strong>
      </p>
      <p>
        <strong>
          <em>-</em>
        </strong>
      </p>
    </div>
  )
}

export default DisposalDescription
